export default {
  'Letter': {
    'height': 11,
    'width': 8.5,
  },
  'Half letter': {
    'height': 5.5,
    'width': 8.5,
  },
  'Junior legal': {
    'height': 5,
    'width': 8,
  },
};